import axios from 'axios';
import Web3 from 'web3';

const Eth = require('ethjs-query');
const EthContract = require('ethjs-contract');
const abi = require('../lib/spritelycore.json');

let web3;
if (Web3.givenProvider) {
  web3 = new Web3(Web3.givenProvider);
}

const address = '0x0b4E896694100Fc23123c52f1bf2C575576e1C92';

export default {
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async getBlockchainSprites() {
      if (!web3) return [];

      const eth = new Eth(Web3.givenProvider);
      const contract = new EthContract(eth);
      const MiniToken = contract(abi);
      const miniToken = MiniToken.at(address);
      this.miniToken = miniToken;
      const accounts = await web3.eth.getAccounts();
      const currentAccount = accounts[0];
      if (!currentAccount) return [];
      this.currentEthAccount = currentAccount;

      const sprites = await this.miniToken.getSpritesForUser(this.currentEthAccount);
      const spriteIds = sprites[0].map(sprite => sprite.words[0]);

      return spriteIds;
    },
    async getSpritesFromChain() {
      if (this.loading) return;
      this.loading = true;

      const spriteIds = await this.getBlockchainSprites();

      // @TODO: WE don't always need this
      const response = await axios.get(`/monsters/blockchain-activity?spriteIds=${spriteIds.join(',')}`);
      if (response.data.monsters.length > 1) this.$store.state.usersMonsters = response.data.monsters;

      spriteIds.forEach((spriteId) => {
        const found = this.$store.state.usersMonsters.find((monster) => {
          return monster.tokenId && (monster.tokenId === `${spriteId}` || monster.tokenId === spriteId);
        });

        if (!found) {
          this.$store.state.usersMonsters.push({
            name: `Monster ${spriteId}`,
            tokenId: spriteId,
            recentActivity: [],
            experience: 0,
            level: 0,
          });
        }
      });

      this.loading = false;
    },
  },
  watch: {
    metaMaskAvailable() {
      this.getSpritesFromChain();
    },
    favoriteMonster() {
      this.$store.state.usersMonsters = [];

      const buddy = Object.assign({}, this.favoriteMonster);
      this.$store.state.usersMonsters.push(buddy);

      this.getSpritesFromChain();
    },
  },
  computed: {
    favoriteMonster() {
      return this.$store.state.favoriteMonster;
    },
    userSprites() {
      return this.$store.state.usersMonsters;
    },
    metaMaskAvailable() {
      return this.$store.state.metaMaskStatus;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/blockchainSprites.js